<template>

    <div>

        <table class="table border-bottom" style="margin-bottom: 0px;font-size: .85rem;">
            <tbody>

            <tr class="info-row">
                <td colspan="2" class="editor-content bg-primary text-white"><strong>Row</strong></td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Background</td>
                <td class="editor-content">
                    <select class="form-control editor-form editor-select" v-model="row.background.type" @change="onBgTypeChange">
                        <option>color</option>
                        <option>image</option>
                        <option>pattern</option>
                        <option>none</option>
                    </select>
                </td>
            </tr>

            <tr v-if="row.background === undefined || row.background.type === 'color'">
                <td class="editor-content editor-label">Fill</td>
                <td class="editor-content">
                    <select class="form-control editor-form editor-select" v-model="row.background.gradient">
                        <option>solid</option>
                        <option>linear gradient</option>
                        <option>radial gradient</option>
                    </select>
                </td>
            </tr>

            <tr v-if="row.background === undefined || row.background.type === 'color'">
                <td class="editor-content editor-label">Bg Color</td>
                <td class="editor-content">
                    <color-picker :color-object="row.background" color-field="color" class="mt-1" :shift-left="true"></color-picker>
                </td>
            </tr>

            <tr v-if="(row.background === undefined || row.background.type === 'color') && row.background.gradient && row.background.gradient.indexOf('gradient') > -1 ">
                <td class="editor-content editor-label">2nd Color</td>
                <td class="editor-content">
                    <color-picker :color-object="row.background" color-field="secondaryColor" class="mt-1" :shift-left="true"></color-picker>
                </td>
            </tr>

            <tr v-else-if="row.background.type === 'image'">
                <td class="editor-content editor-label">Background Image</td>
                <td class="editor-content">
                    <button class="btn btn-sm btn-success" @click="onBackgroundClick">select image</button>
                </td>
            </tr>

            <tr v-else-if="row.background.type === 'pattern'">
                <td class="editor-content editor-label">Background Pattern</td>
                <td class="editor-content">
                    <button class="btn btn-sm btn-success" @click="onEditPatternClick">select pattern</button>
                </td>
            </tr>

            <tr v-if="row.background.type === 'image'">
                <td class="editor-content editor-label">Image Overlay</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="row.background.imageOverlay">
                </td>
            </tr>

            <tr v-if="row.background.type === 'image' && row.background.imageOverlay">
                <td class="editor-content editor-label">Overlay Color</td>
                <td class="editor-content">
                    <color-picker :color-object="row.background.color" class="mt-1" :shift-left="true"></color-picker>
                </td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Min Height</td>
                <td class="editor-content">
                    <input class="form-control editor-form" type="number" v-model="row.minHeight"/>
                </td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Container</td>
                <td class="editor-content">
                    <input type="checkbox" id="checkbox" v-model="row.includeContainer">
                </td>
            </tr>

            <tr class="info-row">
                <td colspan="2" class="editor-content">Padding</td>
            </tr>

            <margin-selector :spacing="row.padding"></margin-selector>

            </tbody>
        </table>

    </div>
</template>

<script>
    import PageFactory from "../../utils/PageFactory";
    import MarginSelector from "./MarginSelector.vue";
    import ColorPicker from "../../components/ColorPicker.vue";

    export default {
        name: 'RowProperties',
        components: {ColorPicker, MarginSelector},
        props: ['layout', 'page'],
        data() {
            return {
                model: webase.model,
                factory: new PageFactory()
            }
        },
        computed: {
            row() {
                return this.layout.selectedRow
            }
        },
        methods: {
            onBackgroundClick() {
                webase.eventDispatcher.emit('updateBackgroundClick')
            },
            onEditPatternClick() {
                webase.eventDispatcher.emit('editBackgroundPatternClick')
            },
            onBgTypeChange() {
                if(this.row.background.type === 'image') {
                    this.onBackgroundClick()
                }
                else if(this.row.background.type === 'pattern') {
                    this.onEditPatternClick()
                }
            }
        }
    }
</script>
